<!--
// app/pages/mena/index.vue
-->
<script setup lang="ts">
import TheHeader from "~/app/components/layout/TheHeader.vue";
import MainGradientDivider from "~/app/components/context-shared/MainGradientDivider.vue";
import BannerCompetitionName from "~/app/components/context-shared/BannerCompetitionName.vue";
import ContextOtherLeaguesLogo from "~/app/components/context-shared/ContextOtherLeaguesLogo.vue";
import SocialIcons from "~/app/components/Shared/SocialIcons.vue";
import { useWebContext } from "~/app/composables/webContext";
import HubSpotForm from "~/app/components/pages/region-tickets/HubSpotForm.vue";
import BannerJoinTheDraft from "~/app/components/Shared/landings/BannerJoinTheDraft.vue";

false && /*#__PURE__*/ defineI18nRoute(false);

definePageMeta({
  middleware: ["not-found-queens"],
  layout: false,
});

const { isKings } = useWebContext();
const { setLocaleCookie } = useI18n();

setLocaleCookie("en");

const socialProfilesMena = {
  youtube: "https://www.youtube.com/@KingsLeagueMENA",
  twitter: "https://x.com/KingsLeagueMENA",
  tiktok: "https://www.tiktok.com/@kingsleague_mena",
};

const actualYear = new Date().getFullYear();
const bgMenaLanding = "/img/landings/bg-landing-mena.jpg";
const formId = "8820e94c-b3f8-46ae-9d07-3097456c70d4";
const linkDraft = "https://mena.apply.kingsleague.pro/";

const showJoinDraft = ref(true);
const withVideo = true;

useHead({
  htmlAttrs: () => [
    {
      lang: "ar-001",
      dir: "rtl",
    },
  ],
  link: false,
  titleTemplate: "Kings League MENA",
});

useSeoMeta({
  ogImage: "/img/league-og-image/og-mena.jpg",
  ogType: "website",
  ogUrl: "https://kingsleague.pro/mena",
  description: "Kings League – كرة القدم الحقيقية",
  ogDescription: "Kings League – كرة القدم الحقيقية",
});

const toolbarVisible = ref(true);
const eventListeners = ["scroll", "resize"];
onMounted(() => {
  eventListeners.forEach(event => {
    window.addEventListener(event, () => {
      toolbarVisible.value = !(window.scrollY > 28 || window.innerWidth < 1200);
    });
  });
});
</script>

<template>
  <the-header :toolbar-visible="toolbarVisible" is-mena-landing></the-header>

  <main class="main" :class="toolbarVisible ? 'mt-0' : 'mt-[130px] lg:mt-[152px]'">
    <section
      class="mx-auto min-h-screen md:min-h-[calc(100vh-20vh)] bg-cover bg-right-top bg-no-repeat md:py-20"
      :style="`background-image:url('${bgMenaLanding}');`"
    >
      <div class="max-w-6xl mx-auto">
        <div class="flex flex-col md:flex-row justify-between gap-6 items-center">
          <banner-join-the-draft
            v-if="showJoinDraft && withVideo"
            :draft-form-link="linkDraft"
            league-logo="/img/league-logos/kl-mena.png"
            league-logo-alt="Kings League MENA"
            button-text="انضم إلى الدرافت"
            claim-before-button="انضم إلى دوري الملوك وكن لاعبًا!"
            only-mobile
          ></banner-join-the-draft>
          <div class="md:max-w-lg px-4">
            <h1 class="text-primary text-3xl uppercase font-bold font-[termina]">
              من الرياض تبدأ قصة كينقز ليق مينا!
            </h1>

            <p class="mt-8">
              فِرق يقودها أشهر الستريمرز في الشرق الأوسط وشمال أفريقيا، جاهزة تتنافس بقوة على اللقب.
            </p>

            <p class="my-4">
              نظام جديد يجمع بين الرياضة والترفيه، وقواعد ثورية تجعل المباريات أكثر حماس ومتعة.
            </p>

            <p class="font-bold my-4">
              سجّل الآن وخلّك أول من يعرف كل جديد، أو قدّم طلبك وانضم للتاريخ مع أول نسخة من كينقز ليق مينا!
            </p>

            <div class="min-h-[378px] max-w-md">
              <hub-spot-form :form-id="formId" src="//js-eu1.hsforms.net/forms/embed/v2.js" />
            </div>
          </div>

          <div
            v-if="!withVideo"
            class="order-first w-full md:order-2 md:w-[771px] h-full flex justify-center"
          >
            <banner-join-the-draft
              v-if="showJoinDraft"
              :draft-form-link="linkDraft"
              league-logo="/img/league-logos/kl-mena.png"
              league-logo-alt="Kings League MENA"
              button-text="انضم إلى الدرافت"
              claim-before-button="انضم إلى دوري الملوك وكن لاعبًا!"
            ></banner-join-the-draft>
            <img
              v-else
              src="/img/league-logos/kl-mena.png"
              alt="Kings League MENA"
              class="my-4 max-w-[225px] md:max-w-[350px]"
            />
          </div>

          <div
            v-if="withVideo"
            class="md:flex flex-col items-center md:items-start justify-center h-auto max-w-full mb-6 md:mb-0 px-4"
          >
            <iframe
              height="350"
              width="100%"
              class="max-w-[771px] max-h-[235px] sm:max-h-none aspect-video rounded-3xl outline-none"
              src="https://www.youtube-nocookie.com/embed/jz32Wy0BrEg?rel=0"
              title="Kings League MENA"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>

            <div class="hidden md:block self-center min-w-[50%]">
              <p class="mt-4 md:mt-6 !mb-2 text-sm sm:text-base md:text-lg text-center">
                انضم إلى دوري الملوك وكن لاعبًا!
              </p>
              <a :href="linkDraft" target="_blank" class="block btn btn-emphasis text-center">
                <span class="font-bold font-['Termina'] leading-none uppercase">انضم إلى الدرافت</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>

  <footer>
    <main-gradient-divider height="h-2.5"></main-gradient-divider>
    <banner-competition-name></banner-competition-name>
    <div class="kql-w-container py-10 px-4 md:px-6">
      <div class="container-items-footer">
        <div>
          <div class="flex flex-col items-start justify-between gap-y-5">
            <img
              src="/img/league-logos/Footer-kings-league-mena.png"
              alt="Kings League MENA"
              width="312"
              height="81"
              class="logo"
            />
            <social-icons :social-profiles="socialProfilesMena"></social-icons>
          </div>
        </div>
        <div class="mt-8 md:mt-0 flex items-start justify-start md:justify-end"></div>
        <div class="pt-12 md:pt-0 flex justify-start md:justify-end">
          <context-other-leagues-logo height="h-[66px]"></context-other-leagues-logo>
        </div>
      </div>
      <div class="pt-8 text-xs text-gray-500 flex flex-col md:flex-row justify-between">
        <p>© All rights reserved. Kings League. {{ actualYear }}</p>

        <div class="legal-block">
          <div class="lawwwing-document-open notice">
            {{ $t("footer.lawwwing.legalNotice") }}
          </div>
          <span class="legal-divider">|</span>
          <div class="lawwwing-document-open priv">
            {{ $t("footer.lawwwing.privacyPolicy") }}
          </div>
          <span class="legal-divider">|</span>
          <a href="https://kings-queens-league.factorialhr.es/complaints" target="_blank">{{
            $t("footer.speakUp")
          }}</a>
          <span class="legal-divider">|</span>
          <div class="lw-consent-edit">{{ $t("footer.lawwwing.settings") }}</div>
          <span v-if="isKings" class="legal-divider">|</span>
          <div v-if="isKings" class="onesignal-customlink-container"></div>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.main {
  min-height: calc(theme(height.screen) - 20vh);
}

.container-items-footer {
  @apply pb-12 border-b border-black gap-x-10 lg:gap-x-24 grid grid-cols-1 items-start md:grid-cols-[384px_auto_114px];
}

.legal-block {
  @apply flex flex-col mt-2 gap-2 md:mt-0 md:flex-row md:items-center md:justify-between md:gap-4;
}

.legal-block div,
.legal-block a {
  @apply hover:cursor-pointer hover:underline;
}

.legal-divider {
  @apply hidden md:block;
}

.logo {
  @apply w-[189px] md:w-[312px] h-auto;
}
</style>
